module.exports = __webpack_public_path__ + "static/media/close-icon-mobile-white.a94d1b29.svg";